import { BaseObjectFacade } from '../../../core/business-objects/base-object/base-object.facade';
import { BaseObject } from '../../../core/business-objects/base-object/base-object.model';
import { VasBaseObjectApiFacade } from './vas-base-object.api-facade';
import { VasBaseObjectStoreFacade } from './vas-base-object-store.facade';
import { VasAppFacade } from '../../services/vas-app-facade.service';
import { Observable } from 'rxjs/Observable';
import { schema } from 'normalizr';

export abstract class VasBaseObjectFacade<T extends BaseObject, A extends VasBaseObjectApiFacade<T>, S extends VasBaseObjectStoreFacade<T>> extends BaseObjectFacade<T, A, S> {

    constructor(
        protected entityName: string,
        protected appFacade: VasAppFacade,
        protected apiFacade: A,
        protected storeFacade: S,
        protected entitySchema: schema.Entity
    ) {
        super(entityName, appFacade, apiFacade, storeFacade);
    }

    canDelete(object: T): Observable<boolean> {
        return Observable.zip(
            this.appFacade.objects.membership.store.isActiveUserAdmin().take(1),
            this.appFacade.objects.membership.store.isActiveUserOwner().take(1)
        )
            .map(args => args[0] || args[1])
            .map(result => {
                if (!result) {
                    throw new Error(`Cannot delete this item because you are neither an admin or the account owner`);
                }
                return result;
            });
    }

    protected getSchema(): schema.Entity {
        return this.entitySchema;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/base-object/vas-base-object.facade.ts